
/**
 * The environment configuration object for test environment.
 */
export const environment = {
    production: false,
    name: 'test'
};